import variables  from './css/theme.module.scss';
import createTheme from '@mui/material/styles/createTheme';

// A custom theme for this app
const theme = createTheme({
    palette: {
        primary: {
            main: variables.primary,
        },
        secondary: {
            main: variables.light,
        },
        error: {
            main: '#ff1744',
        },
        background: {
            default: '#fff',
        },
        yellow: {
            main: variables.secondary,
            dark: variables.secondaryDark,
            contrastText: variables.primary
        },
        yellow_2: {
            main: variables.secondary,
            dark: variables.secondaryDark,
            contrastText: variables.primary
        },
        white: {
            main: '#fff',
            dark: variables.lightBackground,
            contrastText: variables.primary
        },
        violet: {
            main: variables.violet,
            dark: variables.violetDark,
            contrastText: variables.primary
        },
        accentDark:{
            main: variables.accentDark,
            dark: variables.statusWarning,
            contrastText: '#fff'
        }       ,
        orange:{
            main: variables.orange,
            dark: variables.orangeDark2,
            contrastText: '#161616'
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'unset',
                    fontFamily: variables.AvenirMedium,
                    letterSpacing: '-0.5px',
                    borderRadius: '5px',
                    boxShadow: 'unset',
                    maxWidth: '100%',
                    padding: '5px 15px',
                    overflow: 'hidden',
                    '&:hover': {
                        boxShadow: 'none',
                    },
                    '&:active': {
                        boxShadow: 'none',
                    },
                    '&:focus': {
                        // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
                    },
                    '&.btn-slim':{
                        padding: '5px 0',
                        minWidth: '40px'
                    },
                    '&.btn-rounded':{
                        borderRadius: '26.5px'
                    },
                    '&.btn-100':{
                        width: '100%'
                    },
                    '&.text-dark':{
                      color: 'black'
                    },
                    '&.btn-rounded-bottom':{
                        borderRadius: '26.5px',
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0
                    },
                },
                containedPrimary: {
                    '&.highlighted':{
                        color: variables.secondary,
                        boxShadow: '0 0 0 4px '+variables.secondary,
                    },
                },
                outlined: {
                    borderRadius: '5px'
                },
                contained: {
                    borderRadius: '5px'
                },
                sizeExtraSmall:{
                    fontSize: '0.725rem',
                    fontFamily: variables.Avenir,
                    padding: '3px 10px'
                },
                sizeSmall:{
                    fontSize: '0.875rem',
                },
                sizeMedium:{
                    fontSize: '1rem',
                },
                sizeLarge:{
                    fontSize: '1.25rem',
                },
                sizeExtraLarge: {
                    fontSize: '1.5rem',
                    padding: '20px'
                },
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip:{
                    fontSize: '0.75rem'
                }
            }
        }
    },
});

export default theme;
